var React = require('react');

function Stackoverflow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_awesome-stack-overflow","data-name":"Icon awesome-stack-overflow","d":"M30.64,31.748,9.949,27.382l-.867,4.155,20.691,4.335Zm5.392-9.2L19.8,8.985l-2.7,3.256L33.336,25.806Zm-3.3,4.2L13.564,17.792,11.8,21.651l19.158,8.934ZM27.605,2.25,24.222,4.787,36.835,21.736,40.219,19.2Zm2.167,34.679H8.627v4.2H29.773Zm4.2,8.458H4.419V32.7H.19V49.616H38.2V32.7H33.97Z","transform":"translate(-0.19 -2.25)","fill":"#fff"}));
}

Stackoverflow.defaultProps = {"id":"stackoverflow_icon","width":"40.029","height":"47.366","viewBox":"0 0 40.029 47.366"};

module.exports = Stackoverflow;

Stackoverflow.default = Stackoverflow;
